import { useSyncExternalStore } from "react";

function getHash() {
    return window.location.hash;
}

function subscribe(callback: () => void) {
    window.addEventListener("hashchange", callback);
    return () => window.removeEventListener("hashchange", callback);
}

export function useHashRoute() {
    return useSyncExternalStore(subscribe, getHash, () => "");
}
